/** Permission helpers from login user.permissions (string[]). */

export function getUserPermissions(user: any): string[] {
  const raw = user?.permissions;
  if (Array.isArray(raw)) {
    return raw.map((p) => (typeof p === "string" ? p : p?.name)).filter(Boolean);
  }
  return [];
}

export function userHasPermission(user: any, permission: string): boolean {
  if (!user) return false;
  // Administrators typically have full booking CRUD via role name
  const roles = user?.roles || [];
  const isAdmin = roles.some(
    (r: any) => (typeof r === "string" ? r : r?.name) === "administrator"
  );
  if (isAdmin) return true;

  return getUserPermissions(user).includes(permission);
}

export function canCreateBooking(user: any): boolean {
  return userHasPermission(user, "create_booking");
}

export function canUpdateBooking(user: any): boolean {
  return userHasPermission(user, "update_booking");
}
